import {UPDATE_EVENT_DETAILS} from '~/CreateFabricGreetingCard/reducers/details/constants';
import {INIT_APP} from '~/common/fabric/constants';
import {webViewSetIsPremium} from '../../webview/webview';

// No real state here - we just listen for events that the apps need to be notified for
// Not a normal reducer - just a bridge to let the mobile apps know when certain actions occur

const initialState = {};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_EVENT_DETAILS: {
      const premium = action.payload.isPremium;
      if (typeof premium !== 'undefined') setTimeout(() => webViewSetIsPremium(premium), 100);
      return state;
    }
    case INIT_APP: {
      const {event, template} = action.payload;
      let isPremium = event?.is_fabric_premium;
      if (!event) isPremium = template.premium;
      setTimeout(() => webViewSetIsPremium(isPremium), 100);
      return state;
    }
    default:
      return state;
  }
}
